import apollo from 'graphql/apollo';
import { createStaticItemMutation } from 'graphql/mutations';
import { grabFirstGQLDataResult } from 'utils/helpers';

const createStaticItem = async ({ categoryId, name, value, categoryListQuery }) =>
  apollo.mutate({
    mutation: createStaticItemMutation,
    variables: { categoryId, modifier: { name, value: `${value}` } },
    update: (cache, { data }) => {
      const result = grabFirstGQLDataResult(data);
      const cachedData = cache.readQuery({ query: categoryListQuery });
      cache.writeQuery({
        query: categoryListQuery,
        data: {
          categories: cachedData.categories.map((c) =>
            c._id === categoryId ? { ...c, staticItems: [...(c.staticItems || []), result] } : c,
          ),
        },
      });
    },
  });
export default createStaticItem;
